import { Link } from '@mui/material';
import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import { Formatters } from 'app/utils/formatters';

interface SeamRequestLinkProps {
    id: string;
    onClick?: React.MouseEventHandler;
}

/**
 * Just a standard way for representing link to SEAM request page from other places in the app.
 *
 * @param id
 * @param children
 * @param onClick
 * @constructor
 */
export const SeamRequestLink: React.FunctionComponent<SeamRequestLinkProps> = ({ id, children, onClick }) => (
    <Link to={`/seam/request/${id}/details`} onClick={onClick} component={RouterLink} underline='hover'>
        {Formatters.seamRequestId(id)}
        {children}
    </Link>
);
